import { useEffect, useState } from 'react';

export function useObservedElementWidth(elementRef) {
  const [widthPx, setWidthPx] = useState(null);

  useEffect(() => {
    const el = elementRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;

    const measure = () => {
      const w = el.getBoundingClientRect().width;
      setWidthPx(Number.isFinite(w) && w > 0 ? Math.round(w) : null);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [elementRef]);

  return widthPx;
}
